import { api } from './client'

export type ProductImagePhase = 'sync' | 'harvest' | 'ingest' | 'dedup' | 'meta'
type HealthStatus = 'ok' | 'degraded' | 'aus'
export interface ProductImageHealthData {
  status: HealthStatus
  timestamp: string
  flags: { nightly: boolean; backup: boolean }
  nightly: {
    status: HealthStatus
    phase: ProductImagePhase | 'done' | null
    state: 'running' | 'paused' | 'done' | 'partial' | 'skipped' | null
    completed: ProductImagePhase[]
    lastSuccess: string | null
    durationMs: number
    counters: { gespeichert: number; schon_da: number; uebersprungen: number; fehlerhaft: number }
    openErrors: number
    errors: { phase: ProductImagePhase; key: string; grund: string }[]
    coverage: string[]
  }
  backup: {
    status: HealthStatus
    pendingFiles: number
    oldestPendingAt: string | null
    oldestPendingAgeHours: number | null
  }
}

export const getProductImageHealth = () => api.get<ProductImageHealthData>('/health/produktbilder/')
